import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Stack } from '@metarouter-private/mr-mui';

import { AuditLogDateRange } from 'app/audit-logs/audit-logs-date-range';

import ChildTypeSelector from './ChildTypeSelector';
import ChildSelector from './ChildSelector';
import ActionSelector from './ActionSelector';
import UserFilter from './UserFilter';
import auditLogPropTypes from 'app/audit-logs/auditLogPropTypes';

export default function AuditLogFilterBar({
  recordRef,
  filters,
  distinctActions,
  onChildTypeChange,
  onChildIdChange,
  onActionChange,
  onUserSearchTermChange,
  onDateRangeChange,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Stack spacing={2}>
          <ChildTypeSelector recordRef={recordRef} value={filters.childType} onChange={onChildTypeChange} />
          <ActionSelector actions={distinctActions} value={filters.action} onChange={onActionChange} />
          {filters.childType && (
            <ChildSelector
              recordRef={recordRef}
              childType={filters.childType}
              value={filters.childId}
              onChange={onChildIdChange}
            />
          )}
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack spacing={2}>
          <UserFilter value={filters.userSearchTerm} onChange={onUserSearchTermChange} />
          <AuditLogDateRange onDatesChange={buildOnDatesChange(onDateRangeChange)} />
        </Stack>
      </Grid>
    </Grid>
  );
}

AuditLogFilterBar.propTypes = {
  recordRef: auditLogPropTypes.recordRef.isRequired,
  filters: PropTypes.object.isRequired,
  distinctActions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChildTypeChange: PropTypes.func.isRequired,
  onChildIdChange: PropTypes.func.isRequired,
  onActionChange: PropTypes.func.isRequired,
  onUserSearchTermChange: PropTypes.func.isRequired,
  onDateRangeChange: PropTypes.func.isRequired,
};

function buildOnDatesChange(onDateRangeChange) {
  // MrDateRangePicker calls onDatesChange with a partial {startDate, endDate} while only one
  // side of the range has been picked; buildFilterTerms (packages/api) assumes both are present
  // whenever dateRange is non-null, so a partial selection is forwarded as "no date filter yet".
  return ({ startDate, endDate }) => {
    onDateRangeChange(startDate && endDate ? { startDate, endDate } : null);
  };
}
